angular
  .module('countriesApp')
  .service('FundingReportsService', [
    '$q',
    'alertHandlingService',
    'FundingReportModel',
    'RequestService',
    function (
      $q,
      AlertHandling,
      FundingReport,
      Request
    ) {
      const fundingInfos = {
        'data': null,
        'total': null
      };
      const contracts = {
        'data': null,
        'total': null
      };
      const programs = {
        'data': null,
        'total': null
      };
      let country = null;

      /**
       * Performs a request to the API. It directly returns the response data (no model here), also
       * handles if there is an error during the request
       *
       * @param {number} id - Country ID
       * @param {string} type - Type of funding project the BE should return
       *                        Possible values:
       *                        - 'FUNDING_INFOS'
       *                        - 'CONTRACTS'
       *                        - 'PIPELINES'
       * @param {Function} callback - Function to be executed after calling the RequestService
       *                              method
       *
       * @returns {object} - Request promise object
       */
      const request = (id, type, callback) => {
        country = id;

        return Request.getFundingReportsByCountry(id, type)
          .then(callback)
          .catch(() => {
            AlertHandling.showGenericErrorMessage();

            return null;
          });
      };

      /**
       * Performs a GET request to the API to get funding infos list only if the promise is not
       * already running
       *
       * @param {number} id - Country ID
       *
       * @returns {object} - Country promise object
       */
      const getFundingInfosByCountry = id => {
        if (fundingInfos.data && country === id) {
          return $q(resolve => resolve(fundingInfos));
        }

        const type = 'FUNDING_INFOS';

        const callback = response => {
          const fundingInfoResults = response.data.data;

          fundingInfos.total = response.data.total;
          fundingInfos.data = fundingInfoResults.map(info => new FundingReport(info));

          return fundingInfos;
        };

        return request(id, type, callback);
      };

      /**
       * Performs a GET request to the API to get contracts list only if the promise is not already
       * running
       *
       * @param {string} id - Country ID
       *
       * @returns {object} - Country promise object
       */
      const getContractsByCountry = id => {
        if (contracts.data && country === id) {
          return $q(resolve => resolve(contracts));
        }

        const type = 'CONTRACTS';

        const callback = response => {
          const contractResults = response.data.data;

          contracts.total = response.data.total;
          contracts.data = contractResults.map(info => new FundingReport(info));

          return contracts;
        };

        return request(id, type, callback);
      };

      /**
       * Performs a GET request to the API to get programs list only if the promise is not already
       * running
       *
       * @param {number} id - Country ID
       *
       * @returns {object} - Country promise object
       */
      const getProgramsByCountry = id => {
        if (programs.data && country === id) {
          return $q(resolve => resolve(programs));
        }

        const type = 'PIPELINES';

        const callback = response => {
          const programsResults = response.data.data;

          programs.total = response.data.total;
          programs.data = programsResults.map(info => new FundingReport(info));

          return programs;
        };

        return request(id, type, callback);
      };

      /**
       * Generates the filters for the funding search path
       *
       * @param {string} type - Type of report
       * @param {string} [countryName] - The name of the country that will be used as places filter
       *
       * @returns {string} - Absolute path to funding search with a type filter
       *                     applied and (optionally) a places filter
       */
      const getPathFilters = (type, countryName) => {
        const filters = {
          filter: {
            type: [type]
          }
        };

        if(countryName) {
          filters.filter.places = [countryName];
        }

        return filters;
      };

      return {
        getFundingInfosByCountry,
        getProgramsByCountry,
        getContractsByCountry,
        getPathFilters
      };
    }
  ]);
